let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("adwGb")).then(() => parcelRequire('34LZI'));